import { useEffect } from 'react';
import UsersPageStore from './UsersPageStore';

/** Loads organization analytics access so read-only org pricing tier can be shown when `orgId` changes. */
export function UserEditSyncOrganizationPricingTier(props: { orgId?: string; usersPage: UsersPageStore }) {
    const { orgId, usersPage } = props;
    useEffect(() => {
        void usersPage.loadOrganizationPricingTier(orgId);
    }, [orgId, usersPage]);
    return null;
}
